import React, { useEffect, useState } from 'react';
import moment from 'moment';
import styled from 'styled-components';
import Container from 'ls-common-client/dist/components/Container';
import HorizontalScroll from '../../HorizontalScroll';
import RoundButton from '../../RoundButton';
import LazyLoad from '../../LazyLoad';
import Truncate from '../../Truncate';
import useApi from '../../../hooks/useApi';
import utmUrl from '../../../utils/utmUrl';
import './styles.css';

const StyledLayoutContainer = styled(Container)`
  max-width: 1300px;
  margin: 0 auto;
  padding-right: 30px;
  padding-left: 30px;
  @media (max-width: 767px) {
    padding-left: 25px;
    padding-right: 25px;
  }
`;

const LifestyleBlogs = ({ ...props }) => {
  const [blogs, setBlogs] = useState([]);

  const { data, fetch } = useApi('Blogs');

  const { blogs: dataBlogs } = data || {};

  useEffect(() => {
    if (dataBlogs && !!dataBlogs.length) {
      setBlogs(dataBlogs);
    }
  }, [dataBlogs]);

  useEffect(() => {
    if (blogs && !blogs.length)
      fetch({
        params: {
          size: 4,
        },
      });
  }, [blogs]);

  if (blogs && !!blogs)
    return (
      <div className="LifestyleBlogs__root" {...props}>
        <StyledLayoutContainer>
          <div className="LifestyleBlogs__content">
            <div className="LifestyleBlogs__heading">
              Australian Lifestyle Blog
            </div>
            <p className="LifestyleBlogs__subHeading">
              Explore tips, tricks and helpful information on topics you find
              interesting.
            </p>

            <div>
              <HorizontalScroll
                lockScroll
                className="LifestyleBlogs__row"
                arrows
                data={blogs.map(
                  (
                    {
                      title,
                      url,
                      image,
                      author_name: author,
                      date,
                      author_avatar: avatar,
                    },
                    key
                  ) => (
                    <div key={key.toString()} className="LifestyleBlogs__col">
                      <div className="LifestyleBlogs__colInner">
                        <a
                          rel="noopener noreferrer"
                          className="LifestyleBlogs__link"
                          href={utmUrl(url, {
                            medium: 'australian_lifestyle_blog_section',
                            campaign: 'australian_lifestyle_blog',
                          })}
                          target="_blank"
                        >
                          {title}
                        </a>
                        <LazyLoad
                          className="LifestyleBlogs__image"
                          style={{
                            backgroundImage: `url(${image})`,
                          }}
                        >
                          <RoundButton
                            className="LifestyleBlogs__hover"
                            tag="div"
                            theme="outlineBlue"
                          >
                            Take me to this article
                          </RoundButton>
                        </LazyLoad>
                        <div className="LifestyleBlogs__title">
                          <Truncate lines={2}>
                            <div>{title}</div>
                          </Truncate>
                        </div>
                        <div className="LifestyleBlogs__meta">
                          {avatar && (
                            <div
                              className="LifestyleBlogs__avatar"
                              style={{
                                backgroundImage: `url(${avatar})`,
                              }}
                            />
                          )}
                          <div>
                            <p className="LifestyleBlogs__name">{author}</p>
                            <p className="LifestyleBlogs__date">
                              {moment(new Date(date)).format('d MMMM YYYY')}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                )}
              />
            </div>
          </div>
        </StyledLayoutContainer>
      </div>
    );
  return null;
};

export default LifestyleBlogs;
